export const MIN_AMOUNT_RAISED_TO_DISPLAY = 124000;

export interface AmountVisibilityContext {
  showAmountRaisedSlugs?: readonly string[];
  excludeAmountOfferingSlugs?: readonly string[];
  settingsLoaded: boolean;
  threshold?: number;
}

interface ShouldShowAmountRaisedParams extends AmountVisibilityContext {
  slug?: string | null;
  amountRaised?: string | number | null;
}

const parseAmount = (value: string | number | null | undefined): number => {
  if (typeof value === 'number') return Number.isFinite(value) ? value : NaN;
  if (typeof value !== 'string') return NaN;
  return Number.parseFloat(value.replace(/[^0-9.]/g, ''));
};

export const shouldShowAmountRaised = ({
  slug,
  amountRaised,
  showAmountRaisedSlugs = [],
  excludeAmountOfferingSlugs = [],
  settingsLoaded,
  threshold = MIN_AMOUNT_RAISED_TO_DISPLAY,
}: ShouldShowAmountRaisedParams): boolean => {
  if (!settingsLoaded) return false;
  if (slug && excludeAmountOfferingSlugs.includes(slug)) return false;
  if (slug && showAmountRaisedSlugs.includes(slug)) return true;

  const parsedAmount = parseAmount(amountRaised);
  return Number.isFinite(parsedAmount) && parsedAmount >= threshold;
};
